export default {
	branches: [
		{
			name: "health-and-welfare",
			title: {
				nl: "Zorg en welzijn",
				en: "Care and welfare"
			},
			icon: "gezondheidszorg",
			jobExamples: {
				nl: "(ambulant) begeleider, sporttrainer, verpleegkundige, pedagogisch medewerker",
				en: "(mobile) care worker, sports coach, nurse, educational worker"
			},
			relevantCrimes: [
				{
					name: "mistreatment-small",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "public-violence",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "mistreatment-large",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "public-violence-with-bodily-harm",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "theft",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "fraud",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "drugs-crime",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "threathening",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "sex-offense",
					window: {
						"<23": 100,
						"23+": 100
					}
				},
				{
					name: "murder",
					window: {
						"<23": 20,
						"23+": 20
					}
				}, 
				{
					name: "terrorism",
					window: {
						"<23": 4,
						"23+": 4
					}
				}, 
				{
					name: "arms-offense",
					window: {
						"<23": 4,
						"23+": 4
					}
				}
			]
		},
		{
			name: "education",
			title: {
				nl: "Onderwijs",
				en: "Education"
			},
			icon: "onderwijs",
			jobExamples: {
				nl: "docent, conciërge, onderwijsassistent",
				en: "teacher, caretaker, teaching assistant"
			},
			relevantCrimes: [
				{
					name: "mistreatment-small",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "public-violence",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "mistreatment-large",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "public-violence-with-bodily-harm",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "fraud",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "drugs-crime",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "threathening",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "sex-offense",
					window: {
						"<23": 100,
						"23+": 100
					}
				},
				{
					name: "murder",
					window: {
						"<23": 20,
						"23+": 20
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "arms-offense",
					window: {
						"<23": 4,
						"23+": 4
					}
				}
			]
		},
		{
			name: "childcare",
			title: {
				nl: "Kinderopvang",
				en: "Childcare"
			},
			icon: "kinderopvang",
			jobExamples: {
				nl: "medewerker kinderopvang, gastouder, huisgenoot",
				en: "childcare worker, childminder, housemate"
			},
			relevantCrimes: [
				{
					name: "mistreatment-small",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "public-violence",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "mistreatment-large",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "public-violence-with-bodily-harm",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "theft",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "fraud",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "drugs-crime",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "threathening",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "sex-offense",
					window: {
						"<23": 100,
						"23+": 100
					}
				},
				{
					name: "murder",
					window: {
						"<23": 20,
						"23+": 20
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "arms-offense",
					window: {
						"<23": 4,
						"23+": 4
					}
				}
			]
		},
		{
			name: "financial-service",
			title: {
				nl: "Financiële dienstverlening",
				en: "Financial services"
			},
			icon: "financiele-dienstverlening",
			jobExamples: {
				nl: "accountant, bankmedewerker, hypotheekadviseur",
				en: "accountant, bank employee, mortgage advisor"
			},
			relevantCrimes: [
				{
					name: "theft",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "fraud",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "murder",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
			]
		},
		{
			name: "extraordinary-police-officer",
			title: {
				nl: "Buitengewoon Opsporingsambtenaar",
				en: "Special enforcement officer"
			},
			icon: "buitengewoon-opsporingsambtenaar",
			jobExamples: {
				nl: "sociaal rechercheur, handhaver openbare ruimte, controleur openbaar vervoer",
				en: "social security investigator, public space enforcement officer, public transport inspector"
			},
			relevantCrimes: [
				{
					name: "mistreatment-small",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "public-violence",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "mistreatment-large",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "public-violence-with-bodily-harm",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "theft",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "fraud",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "drugs-crime",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "threathening",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "sex-offense",
					window: {
						"<23": 100,
						"23+": 100
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "traffic-crime",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "murder",
					window: {
						"<23": 20,
						"23+": 20
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "arms-offense",
					window: {
						"<23": 10,
						"23+": 10
					}
				}
			]
		},
		{
			name: "political-official",
			title: {
				nl: "Politieke ambtsdrager",
				en: "Political office holder"
			},
			icon: "ambtenaar",
			jobExamples: {
				nl: "volksvertegenwoordigers, wethouders, gedeputeerden",
				en: "Representatives of the people, aldermen"
			},
			relevantCrimes: [
				{
					name: "mistreatment-small",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "public-violence",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "mistreatment-large",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "public-violence-with-bodily-harm",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "theft",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "fraud",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "drugs-crime",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "threathening",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "sex-offense",
					window: {
						"<23": 100,
						"23+": 100
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "traffic-crime",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "murder",
					window: {
						"<23": 20,
						"23+": 20
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 10,
						"23+": 10
					}
				},
				{
					name: "arms-offense",
					window: {
						"<23": 10,
						"23+": 10
					}
				}
			]
		},
		{
			name: "transport-and-logistics",
			title: {
				nl: "Transport en logistiek",
				en: "Transport and logistics"
			},
			icon: "transport-en-logistiek",
			jobExamples: {
				nl: "goederenchauffeur, magazijnmedewerker, orderpicker",
				en: "delivery driver, warehouse worker, order picker"
			},
			relevantCrimes: [
				{
					name: "theft",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "fraud",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "drugs-crime",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "traffic-crime",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "murder",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "arms-offense",
					window: {
						"<23": 4,
						"23+": 4
					}
				}
			]
		},
		{
			name: "taxi-branch",
			title: {
				nl: "Taxibranche",
				en: "Taxi sector"
			},
			icon: "taxi",
			jobExamples: {
				nl: "taxichauffeur, taxiondernemer",
				en: "taxi driver, taxi operator"
			},
			relevantCrimes: [
				{
					name: "mistreatment-small",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "public-violence",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "mistreatment-large",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "public-violence-with-bodily-harm",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "theft",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "fraud",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "drugs-crime",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "threathening",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "sex-offense",
					window: {
						"<23": 100,
						"23+": 100
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "traffic-crime",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "murder",
					window: {
						"<23": 20,
						"23+": 20
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 5,
						"23+": 5
					}
				},
				{
					name: "arms-offense",
					window: {
						"<23": 5,
						"23+": 5
					}
				}
			]
		},
		{
			name: "ict",
			title: {
				nl: "ICT",
				en: "IT"
			},
			icon: "ict",
			jobExamples: {
				nl: "informatieanalist, developer,  systeembeheerder",
				en: "information analyst, developer, system administrator"
			},
			relevantCrimes: [
				{
					name: "fraud",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "theft",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "sex-offense",
					window: {
						"<23": 100,
						"23+": 100
					}
				},
				{
					name: "murder",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
			]
		},
		{
			name: "construction-and-technology",
			title: {
				nl: "Bouw en techniek",
				en: "Construction and engineering"
			},
			icon: "techniek",
			jobExamples: {
				nl: "monteur, elektricien, installateur, bouwvakker",
				en: "mechanic, electrician, fitter, construction worker"
			},
			relevantCrimes: [
				{
					name: "theft",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "murder",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
			]
		},
		{
			name: "public-order-and-safety",
			title: {
				nl: "Openbare orde en veiligheid",
				en: "Public order and safety"
			},
			icon: "openbare-orde-en-veiligheid",
			jobExamples: {
				nl: "beleidsmedewerker, preventiemedewerker, adviseur integrale veiligheid",
				en: "policy officer, prevention officer, overall safety adviser"
			},
			relevantCrimes: [
				{
					name: "mistreatment-small",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "public-violence",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "mistreatment-large",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "public-violence-with-bodily-harm",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "theft",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "fraud",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "drugs-crime",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "threathening",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "sex-offense",
					window: {
						"<23": 100,
						"23+": 100
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "traffic-crime",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "murder",
					window: {
						"<23": 20,
						"23+": 20
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 4,
						"23+": 4	
					}
				},
				{
					name: "arms-offense",
					window: {
						"<23": 4,
						"23+": 4
					}
				}
			]
		},
		{
			name: "cleaning",
			title: {
				nl: "Schoonmaak",
				en: "Cleaning"
			},
			icon: "schoonmaak",
			jobExamples: {
				nl: "schoonmaakmedewerker, huishoudster, interieurverzorger",
				en: "cleaning worker, housekeeper, interior cleaner"
			},
			relevantCrimes: [
				{
					name: "theft",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "sex-offense",
					window: {
						"<23": 100,
						"23+": 100
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "murder",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 4,
						"23+": 4
					}
				}
			]
		},
		{
			name: "retail",
			title: {
				nl: "Detailhandel",
				en: "Retail"
			},
			icon: "detailhandel",
			jobExamples: {
				nl: "verkoper, caissière, filiaalmanager",
				en: "salesperson, cashier, branch manager"
			},
			relevantCrimes: [
				{
					name: "fraud",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "theft",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "murder",
					window: {
						"<23": 4,
						"23+": 4
					}
				}
			]
		},
		{
			name: "service-industry",
			title: {
				nl: "Horeca",
				en: "Hospitality industry"
			},
			icon: "horeca",
			jobExamples: {
				nl: "gastvrouw/-heer, kelner, bedrijfsleider",
				en: "hostess/host, waiter, manager"
			},
			relevantCrimes: [
				{
					name: "theft",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "drugs-crime",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "sex-offense",
					window: {
						"<23": 100,
						"23+": 100
					}
				},
				{
					name: "destruction",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "murder",
					window: {
						"<23": 4,
						"23+": 4
					}
				}
			]
		},
		{
			name: "legal-service",
			title: {
				nl: "Juridische dienstverlening",
				en: "Legal services"
			},
			icon: "juridische-dienstverlening",
			jobExamples: {
				nl: "advocaat, juridisch adviseur, notaris",
				en: "lawyer, legal advisor, civil-law notary"
			},
			relevantCrimes: [
				{
					name: "theft",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "fraud",
					window: {
						"<23": 2,
						"23+": 4
					}
				},
				{
					name: "street-robbery",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "drugs-crime",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "sex-offense",
					window: {
						"<23": 100,
						"23+": 100
					}
				},
				{
					name: "murder",
					window: {
						"<23": 20,
						"23+": 20
					}
				},
				{
					name: "terrorism",
					window: {
						"<23": 4,
						"23+": 4
					}
				},
				{
					name: "arms-offense",
					window: {
						"<23": 4,
						"23+": 4
					}
				}
			]
		},
	],
	crimes: [
		{
			name: {
				nl: "Verkeersdelict",
				en: "Traffic offence"
			},
			value: "traffic-crime"
		},
		{
			name: {
				nl: "Drugsdelict",
				en: "Drugs offence"
			},
			value: "drugs-crime"
		},
		{
			name: {
				nl: "Fraude",
				en: "Fraud"
			},
			value: "fraud"
		},
		{
			name: {
				nl: "Diefstal",
				en: "Theft"
			},
			value: "theft"
		},
		{
			name: {
				nl: "Diefstal met geweld",
				en: "Theft with violence"
			},
			value: "street-robbery",
			examples: { 
				nl: "straatroof, overval",
				en: "street robbery, raid"
			}
		},
		{
			name: {
				nl: "Vernieling",
				en: "Criminal damage"
			},
			value: "destruction"
		},
		{
			name: {
				nl: "Openlijke geweldpleging",
				en: "Violence in a public place"
			},
			value: "public-violence"
		},
		{
			name: {
				nl: "Openlijke geweldpleging met lichamelijk letsel",
				en: "Violence in a public place resulting in bodily harm"
			},
			value: "public-violence-with-bodily-harm"
		},
		{
			name: {
				nl: "Mishandeling (eenvoudig)",
				en: "Assault (simple)"
			},
			value: "mistreatment-small"
		},
		{
			name: {
				nl: "Mishandeling (zwaar)",
				en: "Assault (aggravated)"
			},
			value: "mistreatment-large"
		},
		{
			name: {
				nl: "Bedreiging",
				en: "Threatening behaviour"
			},
			value: "threathening"
		},
		{
			name: {
				nl: "Seksueel misdrijf",
				en: "Sexual offence"
			},
			value: "sex-offense"
		},
		{
			name: {
				nl: "Moord/doodslag",
				en: "Murder/manslaughter"
			},
			value: "murder"
		},
		{
			name: {
				nl: "Terrorisme",
				en: "Terrorism"
			},
			value: "terrorism"
		},
		{
			name: {
				nl: "Wapendelict",
				en: "Weapons offence"
			},
			value: "arms-offense"
		}
	],
	punishments: [
		{
			name: {
				nl: "Nog niet bekend",
				en: "Not yet known"
			},
			value: "no-punishment-yet"
		},
		{
			name: {
				nl: "Detentie",
				en: "Detention"
			},
			value: "detention",
			requiresDate: true
		},
		{
			name: {
				nl: "TBS/PIJ",
				en: "Hospital order (TBS)/Placement in a juvenile offenders institution (PIJ)"
			},
			value: "tbs/pij",
			requiresDate: true
		},
		{
			name: {
				nl: "Boete",
				en: "Fine"
			},
			value: "fine"
		},
		{
			name: {
				nl: "Taakstraf/werkstraf",
				en: "Community punishment order"
			},
			value: "community-service"
		},
		{
			name: {
				nl: "Leerstraf",
				en: "Educational order"
			},
			value: "learning-penalty"
		},
		{
			name: {
				nl: "Overige",
				en: "Other"
			},
			value: "other"
		},
		{
			name: {
				nl: "Geen",
				en: "None"
			},
			value: "none"
		}
	],
}
